import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, Link } from "react-router-dom";
import { Check, X, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaymentResult({ variant }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(variant === "success" ? "checking" : "cancelled");

  useEffect(() => {
    if (variant !== "success" || !sessionId) return;
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          clearInterval(timer);
        } else if (attempts > 15) {
          setState("timeout");
          clearInterval(timer);
        }
      } catch {
        if (attempts > 15) {
          setState("timeout");
          clearInterval(timer);
        }
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [variant, sessionId]);

  return (
    <div data-testid="payment-result-page" className="flex min-h-screen items-center justify-center bg-ink px-6">
      <div className="w-full max-w-md border border-white/10 bg-white/[0.03] p-10 text-center">
        {state === "paid" && (
          <>
            <Check className="mx-auto mb-6 h-8 w-8 text-gold-light" strokeWidth={1.5} />
            <h1 className="font-serif text-3xl font-light text-neutral-100">Payment confirmed</h1>
            <p data-testid="payment-confirmed-text" className="mt-4 text-sm font-light text-neutral-400">
              Thank you — your pre-order is confirmed. We will email you as soon as your fragrance ships.
            </p>
          </>
        )}
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto mb-6 h-8 w-8 animate-spin text-gold-light" strokeWidth={1.5} />
            <h1 className="font-serif text-3xl font-light text-neutral-100">Confirming payment</h1>
            <p className="mt-4 text-sm font-light text-neutral-400">One moment while we verify with Stripe…</p>
          </>
        )}
        {state === "cancelled" && (
          <>
            <X className="mx-auto mb-6 h-8 w-8 text-neutral-500" strokeWidth={1.5} />
            <h1 className="font-serif text-3xl font-light text-neutral-100">Payment cancelled</h1>
            <p className="mt-4 text-sm font-light text-neutral-400">No charge was made.</p>
          </>
        )}
        {state === "timeout" && (
          <>
            <h1 className="font-serif text-3xl font-light text-neutral-100">Still processing</h1>
            <p className="mt-4 text-sm font-light text-neutral-400">
              Stripe is taking longer than usual to confirm. Check with me and I'll verify it for you.
            </p>
          </>
        )}
        <Link
          to="/#collection"
          data-testid="back-to-collection"
          className="mt-8 inline-block border border-gold/40 px-6 py-3 text-[11px] uppercase tracking-[0.25em] text-gold-light transition-all duration-500 hover:border-gold hover:bg-gold/10"
        >
          Back to the collection
        </Link>
      </div>
    </div>
  );
}
